import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/course-content-access-methods/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const courseContentAccessMethods = {
  getAll: apiPathFunc(pathBase),
} as const;
